import { Serializable } from '../core/models/serializable';
export class Utils {
  public static cloneObjectRaw(obj: any): any {
    let str = JSON.stringify(obj);
    let newObj = JSON.parse(str);

    return newObj;
  }

  public static cloneObject<T extends Serializable<T>>(
    obj: T,
    type: { new (): T }
  ) {
    let clone = new type();

    let rawClone = this.cloneObjectRaw(obj);

    clone = clone.fromObject(rawClone);

    return clone;
  }

  public static compare(obj1: any, obj2: any): boolean {
    let str1 = JSON.stringify(obj1);
    let str2 = JSON.stringify(obj2);

    return str1 == str2;
  }

  public static toMap<T>(
    items: T[],
    keySelector: (item: T) => string | number
  ): { [index: string]: T } {
    let map: { [index: string]: T } = {};

    if (items && items.length && items.length > 0) {
      items.forEach((c) => {
        map[keySelector(c)] = c;
      });
    }

    return map;
  }

  public static groupBy<T>(
    items: T[],
    keySelector: (item: T) => string | number
  ): { [index: string]: T[] } {
    let grouping = items.reduce((v, c) => {
      v[keySelector(c)] = v[keySelector(c)] || [];
      v[keySelector(c)].push(c);
      return v;
    }, {});
    return grouping;
  }

  public static capitalizeFirstLetter(s: string): string {
    if (s == null || s.length == 0) {
      return s;
    }
    let result = s.charAt(0).toUpperCase();

    if (s.length > 1) {
      result += s.slice(1);
    }

    return result;
  }
}

// export class ObjectBackup<T extends Serializable<T>>
// {
//     private rawObject: any;

//     public storeObject(src: T, type: {new(): T}){
//         this.rawObject = Utils.cloneObject(src);
//     }

//     public restoreObject(type: {new(): T}): T{
//         let result = new type();

//         result = result.fromObject(this.rawObject);

//         return result;
//     }

//     public restoreObjectTo(targetObject: T, type: {new(): T}) {

//         targetObject.fromObject(this.rawObject);
//     }
// }

export class MonthBreakpoint {
  public static readonly THREE: number = 3;
  public static readonly SIX: number = 6;
  public static readonly TWELVE: number = 12;
}
